import React from "react";
import styles from "./SedexData.module.scss";
import Image from "next/image";

function SedexData() {
  return (
    <div className={styles.sedexData}>
      <h6>SEDEX</h6>
      <h2>Elchemy joins Sedex driving ethical supply chain excellence</h2>
      <div className={styles.contentAndImage}>
        <div className={styles.content}>
          <p>
            At Elchemy, we believe that technology and ethics must go
            hand-in-hand. By joining Sedex, we are reinforcing our commitment to
            the highest standards of labor rights, health and safety, and
            environmental stewardship.
          </p>
          {/* <p>Our membership signifies our alignment with:</p> */}
          <ul>
            <li>
              <strong>Labor Standards:</strong> Ensuring fair wages, voluntary
              employment, and the elimination of child labor across our partner
              network.
            </li>
            <li>
              <strong>Health & Safety:</strong> Guaranteeing that every chemical
              we move is handled in facilities that prioritize worker well-being
              and emergency preparedness.
            </li>
            <li>
              <strong>Environmental Stewardship:</strong> Tracking our
              ecological footprint and promoting green chemistry to support our
              clients&apos; Net-Zero goals.
            </li>
            <li>
              <strong>Business Ethics:</strong> Operating with total
              transparency, zero tolerance for corruption, and full legal
              compliance.
            </li>
          </ul>
        </div>
        <div className={styles.imageContainer}>
          <Image
            className={styles.image}
            fill
            alt="sedex-img"
            src="https://d3eh91hyrk4vzb.cloudfront.net/sedex_main.webp"
          />
        </div>
      </div>
    </div>
  );
}

export default SedexData;
